/**
 * @file 欢迎弹窗
 * @author gaoxunchen
 */

import _ from 'lodash';
import React, { useState, useMemo } from 'react';
import { Dialog } from '@tencent/spaui';
import dayjs from 'dayjs';

import { FLAGS } from '@/constants/Constants';
import { getFromCombinedValue, saveCombinedValue } from '@/utils/storage';
import globalStore from '@/stores';

const date = dayjs();

const DialogWelcome: React.FC<any> = (props) => {
  const { schema = {} } = props;
  const { account } = globalStore;
  const [show, setShow] = useState(true);

  const start = _.get(schema, 'start', '2023-05-17');
  const end = _.get(schema, 'end', '2023-09-01');

  const combindKey = FLAGS.AMS_HOME_DIALOG_STORAGE_KEY;
  const key = 'ams_home_dialog_welcome';
  const params = {
    userId: account.user_id,
    useSessionStorage: false,
  };

  const shouldShow = getFromCombinedValue(combindKey, key, params) !== date.format('YYYY-MM-DD');

  const handleClose = () => {
    setShow(false);
    saveCombinedValue(combindKey, key, date.format('YYYY-MM-DD'), params);
  };

  const content = useMemo(() => (
    <img
      src="https://agency-static-1258344696.file.myqcloud.com/fe/img/home-dialog-welcome.png"
      onClick={handleClose}
    />
  ), []);

  return (
    <Dialog
      show={show && shouldShow && date.isAfter(start) && date.isBefore(end)}
      useNewUI
      size="xl"
      style={{ zIndex: 99999999, cursor: 'pointer' }}
      backdrop
      enabledBackdropClose
      hideHeader
      hideFooter
      closeButton={false}
      BodyComponent={() => (
        <>
          {content}
        </>
      )}
      onClose={handleClose}
    />
  );
};

export default DialogWelcome;
